import React from "react"

import { IToggle } from "./model"

import "./style.scss"

/**
 * Generic Checkbox for use through out all applications.
 */
export function Toggle({ id, required, style, name, className, active, callback, children, direction }: IToggle) {
    return (
        <div className={`tgl ${className || ""}`} style={style} id={`${id || ""}`}>
            <label>
                {direction === "rtl" && (
                    <div className="tgl-label">
                        {children}
                        {required && <span> *</span>}
                    </div>
                )}
                <div className={`tgl-background ${active ? "active" : ""}`}>
                    <div className="ball" />
                </div>
                {direction === "ltr" && (
                    <div className="tgl-label">
                        {children}
                        {required && <span> *</span>}
                    </div>
                )}
                <input role="toggle" name={name} type="checkbox" checked={active} onChange={callback} />
            </label>
        </div>
    )
}

export default Toggle

Toggle.defaultProps = {
    direction: "ltr",
}
